import React from 'react';
import './App.css';
import Overview from './components/Overview';
import MemberList from './components/MemberList';
import Contact from './components/Contact';
import anthropic from './assets/partners/anthropic.jpeg';
import cognition from './assets/partners/cognition.jpeg';
import openai from './assets/partners/openai.jpeg';
import scale from './assets/partners/scale.jpeg';
import spacexsi from './assets/partners/spacexsi.jpeg';
import gdm from './assets/partners/gdm.jpeg';
import meta from './assets/partners/meta.jpeg';
import sierra from './assets/partners/sierra.jpeg';
import decagon from './assets/partners/decagon.jpeg';
import modal from './assets/portfolio/modal.jpeg';
import mirendil from './assets/partners/mirendil.jpeg';
import cartesia from './assets/portfolio/cartesia.jpeg';
import arena from './assets/partners/arena.jpeg';
import ac from './assets/partners/ac.jpeg';
import llmh from './assets/partners/llmh.jpeg';
import retailready from './assets/portfolio/retailready.jpeg';
import toma from './assets/portfolio/toma.jpeg';
import worldexLab from './assets/portfolio/worldex_lab.jpeg';
import avoca from './assets/portfolio/avoca.jpeg';
import central from './assets/portfolio/central.jpeg';
import simpleAI from './assets/portfolio/simple_ai.jpeg';
import numiro from './assets/portfolio/numiro.jpeg';
import adaptiveInnovations from './assets/portfolio/adaptive_innovations.jpeg';
import stealth from './assets/portfolio/stealth_company.jpeg';
import santoriLabs from './assets/portfolio/santori_labs.jpeg';
import sequenceHoldings from './assets/portfolio/sequence_holdings.jpeg';
import osmosis from './assets/portfolio/osmosis.jpeg';
import flora from './assets/portfolio/flora.jpeg';
import flint from './assets/portfolio/flint.png';
import rehearsals from './assets/portfolio/rehearsals.jpeg';
import residesk from './assets/portfolio/residesk.jpeg';
import percy from './assets/portfolio/percy.jpeg';
import terac from './assets/portfolio/terac.jpeg';
import sailResearch from './assets/portfolio/sail_research.jpeg';
import omniAI from './assets/portfolio/omni_ai.jpeg';
import delegate from './assets/portfolio/delegate.jpeg';
import preferenceModel from './assets/portfolio/preference_model.jpeg';

// const partners = [
//   { id: 1, name: 'Timothy "Chongz" Luong', description: "Employee at SomeCompany", img: anon_profile },
//   { id: 2, name: "Arno Gao", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 3, name: "Sarah Niyogi", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 4, name: "Albert Sheu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 5, name: "Barrett Woodside", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 6, name: "Eric Lee", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 7, name: "Jonah Bolotin", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 8, name: "Pawan Deshpande", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 9, name: "Calvin Huang", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 10, name: "Fernando Amat Gil", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 11, name: "Alan Yu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 12, name: "Andrew Liu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 13, name: "Argyris Zymnis", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 14, name: "Ashraf Alhashim", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 15, name: "Bihan Jiang", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 16, name: "Catherine Ma", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 17, name: "David Zhu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 18, name: "Drake Wong", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 19, name: "Emily Wen", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 20, name: "Grace Hua", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 21, name: "Matthew Kaufer", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 22, name: "Michael Chen", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 23, name: "Shah Xia", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 24, name: "Shannon Hong", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 25, name: "Sophia Luo", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 26, name: "Tiger Sun", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 27, name: "Tony Zhang", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 28, name: "Will Sheu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 29, name: "Yi Xu", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 30, name: "Yunfeng Bai", description: "Employee at SomeCompany", img: anon_profile },
//   { id: 31, name: "Yuting Duan", description: "Employee at SomeCompany", img: anon_profile },
//   // Add more members as needed
// ];

const portfolioCompanies = [
  { id: 'modal', name: 'Modal', description: 'The serverless platform for AI, data and ML teams', img: modal, link: 'https://modal.com'},
  { id: 'decagon', name: 'Decagon', description: 'Enterprise-grade generative AI for customer support', img: decagon, link: 'https://decagon.ai'},
  { id: 'cartesia', name: 'Cartesia AI', description: 'Architecting AI that learns and interacts like humans', img: cartesia, link: 'https://cartesia.ai'},
  { id: 'sequenceHoldings', name: 'Sequence Holdings', description: 'Technology holding company that acquires established businesses and transforms them with artificial intelligence.', img: sequenceHoldings, link: 'https://seqholdings.com'},
  { id: 'sailResearch', name: 'Sail Research', description: 'The AI Inference provider designed for background agents', img: sailResearch, link: 'https://sailresearch.com'},
  { id: 'avoca', name: 'Avoca AI', description: 'The AI Platform for HVAC, Plumbing and Electrical Businesses', img: avoca, link: 'https://avoca.ai'},
  { id: 'flora', name: 'Flora AI', description: 'Cursor for Creatives', img: flora, link: 'https://www.florafauna.ai/'},
  { id: 'adaptiveInnovations', name: 'Adaptive Innovations', description: 'AI-native Healthcare Provider', img: adaptiveInnovations, link: 'https://www.adaptive.co/'},
  { id: 'simpleAI', name: 'Simple AI', description: 'AI voice that sells', img: simpleAI, link: 'https://www.usesimple.ai/'},
  { id: 'toma', name: 'Toma AI', description: 'AI phone automation for auto dealerships', img: toma, link: 'https://www.toma.so'},
  { id: 'preferenceModel', name: 'Preference Model', description: 'We Scale AI Agent Infrastructure', img: preferenceModel, link: 'https://www.preferencemodel.com/'},
  { id: 'numiro', name: 'Numiro', description: 'AI-powered tax prep', img: numiro, link: 'https://numiro.ai'},
  { id: 'osmosis', name: 'Osmosis', description: 'Online Reinforcement Learning for AI Agents', img: osmosis, link: 'https://osmosis.ai'},
  { id: 'central', name: 'Central AI', description: 'Payroll, benefits and government bullsh*t for startups', img: central, link: 'https://centralhq.com'},
  { id: 'delegate', name: 'Delegate', description: 'Reclaim your time with your zero-setup AI coworker', img: delegate, link: 'https://www.delegateai.app/'},
  { id: 'flint', name: 'Flint', description: 'The AI that autonomously builds and optimizes your web presence for the agentic era', img: flint, link: 'https://www.tryflint.com/'},
  { id: 'omni', name: 'Omni AI', description: 'AI-native electronic medical record (EMR) targeting specialty physician practices', img: omniAI, link: 'https://omni.inc'},
  { id: 'santoriLabs', name: 'Santori Labs', description: 'A modern renaissance lab reimagining how humans and AI work together', img: santoriLabs, link: 'https://santori.ai'},
  { id: 'retailready', name: 'RetailReady', description: 'A unified approach to retail compliance', img: retailready, link: 'https://retailreadyai.com'},
  { id: 'worldexLab', name: 'Worldex Lab', description: 'Building the new internet for kids to connect to the physical world', img: worldexLab, link: 'https://worldexlab.com'},
  { id: 'percy', name: 'Percy', description: 'Accelerating data analysis for research', img: percy, link: 'https://www.percy.tech/'},
  { id: 'rehearsals', name: 'Rehearsals', description: 'Rehearse your next launch with AI replicas, grounded in public data and validated with real humans', img: rehearsals, link: 'https://www.runrehearsals.com/'},
  { id: 'residesk', name: 'Residesk', description: "Uncover what's driving residents & prospects to ❤️ or 🤬 your properties", img: residesk, link: 'https://hello.theresidesk.com/'},
  { id: 'terac', name: 'Terac', description: 'AI-powered interviews that deliver insights in hours', img: terac, link: 'https://terac.com'},
  { id: 'stealth', name: 'Stealth Company', img: stealth},
]

const partnerCompanies = [
  { id: 'scaleAI', name: 'Scale AI', img: scale, link: 'https://scale.com'},
  { id: 'openAI', name: 'OpenAI', img: openai, link: 'https://openai.com'},
  { id: 'anthropic', name: 'Anthropic', img: anthropic, link: 'https://anthropic.com'},
  { id: "gdm", name: "Google DeepMind", img: gdm, link: 'https://deepmind.google'},
  { id: "meta", name: "MSL", img: meta, link: 'https://ai.meta.com'},
  { id: 'spacexsi', name: 'SpaceXSI', img: spacexsi, link: 'https://x.ai'},
  { id: 'cognition', name: 'Cognition', img: cognition, link: 'https://cognition.ai'},
  { id: 'sierra', name: 'Sierra', img: sierra, link: 'https://sierra.ai'},
  { id: 'decagon', name: 'Decagon', img: decagon, link: 'https://decagon.ai'},
  { id: "ac", name: "Applied Compute", img: ac, link: 'https://www.appliedcompute.com/'},
  { id: "mirendil", name: "Mirendil", img: mirendil, link: 'https://mirendil.com'},
  { id: 'cartesia', name: 'Cartesia AI', img: cartesia, link: 'https://cartesia.ai'},
  { id: "arena", name: "Arena", img: arena, link: 'https://arena.ai'},
  { id: "llmh", name: "Long Lake", img: llmh, link: 'https://llmh.com'},
]

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Scale Angels Fund</h1>
        <nav>
          <a href="#overview">Overview</a>
          <a href="#portfolio">Portfolio</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>
      <main>
        <section id="overview">
          <Overview companyCount={portfolioCompanies.length} />
        </section>
        <section id="portfolio">
          <MemberList title="Portfolio" membersData={portfolioCompanies}/>
        </section>
        {/* <section id="partners">
          <MemberList title="Partners" membersData={partners} />
        </section> */}
        <section id="backedBy">
          <MemberList title="Backed By Partners From" membersData={partnerCompanies} small/>
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
    </div>
  );
}

export default App;
